<template>
  <div>
    <div class="modal modal--chat_options" id="chat_options_modal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_game_chat_options_title }}</h1>
        </div>
        <div class="modal__body">
          <div class="chat_icons">
            <div class="chat_icon_option"
                 :key="index"
                 v-for="(image, index) in emojiOptions">
              <a @click.prevent="choose(image, 'EMOJI')"
                 style="cursor: pointer">
                <img class="btn_chat_icon_option"
                     :src="getTranslations[image]"
                     alt="">
              </a>
            </div>
          </div>
          <div class="chat_buttons">
            <div class="chat_button_option"
                 :key="index"
                 v-for="(text, index) in phrases">
              <a @click.prevent="choose(text, 'TEXT')"
                 style="cursor: pointer"
                 class="btn_chat_option">
                {{ getTranslations[text] }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'chatOptions',
  data() {
    return {
      emojiOptions: [
        'home_game_chat_options_emoji1',
        'home_game_chat_options_emoji2',
        'home_game_chat_options_emoji3',
        'home_game_chat_options_emoji4',
      ],
      phrases: [
        'home_game_chat_options_text1',
        'home_game_chat_options_text2',
        'home_game_chat_options_text3',
      ],
    };
  },
  created() {
    this.showModal();
  },
  methods: {
    choose(content, type) {
      this.$emit('chose', { content, type });
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#chat_options_modal').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/game_chat/ChatOptions.vue